/**
 * Stub for zod's locales/index.js (~170KB of locale files).
 * Re-exports a minimal en-like locale for every key so z.locales.* still exists
 * but no heavy locale content is bundled.
 * Must use CommonJS so zod's .cjs chain can require it.
 */
const minimalLocale = () => ({
  localeError: (issue) =>
    (issue && typeof issue.message === 'string' ? issue.message : 'Invalid input'),
});

module.exports = {
  ar: minimalLocale,
  az: minimalLocale,
  be: minimalLocale,
  ca: minimalLocale,
  cs: minimalLocale,
  da: minimalLocale,
  de: minimalLocale,
  en: minimalLocale,
  eo: minimalLocale,
  es: minimalLocale,
  fa: minimalLocale,
  fi: minimalLocale,
  fr: minimalLocale,
  frCA: minimalLocale,
  he: minimalLocale,
  hu: minimalLocale,
  id: minimalLocale,
  is: minimalLocale,
  it: minimalLocale,
  ja: minimalLocale,
  ka: minimalLocale,
  kh: minimalLocale,
  km: minimalLocale,
  ko: minimalLocale,
  lt: minimalLocale,
  mk: minimalLocale,
  ms: minimalLocale,
  nl: minimalLocale,
  no: minimalLocale,
  ota: minimalLocale,
  ps: minimalLocale,
  pl: minimalLocale,
  pt: minimalLocale,
  ru: minimalLocale,
  sl: minimalLocale,
  sv: minimalLocale,
  ta: minimalLocale,
  th: minimalLocale,
  tr: minimalLocale,
  ua: minimalLocale,
  uk: minimalLocale,
  ur: minimalLocale,
  vi: minimalLocale,
  zhCN: minimalLocale,
  zhTW: minimalLocale,
  yo: minimalLocale,
};
